import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "23",
  viewBox: "466.67 280.55 22.99 22.99",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M482.991 289.889L477.403 295.476C477.225 295.654 476.994 295.743 476.762 295.743C476.528 295.743 476.297 295.654 476.119 295.476L473.326 292.682C472.971 292.328 472.971 291.753 473.326 291.399C473.68 291.044 474.254 291.044 474.608 291.399L476.762 293.551L481.707 288.605C482.062 288.25 482.637 288.25 482.991 288.605C483.346 288.959 483.346 289.534 482.991 289.889ZM478.16 280.545C471.822 280.545 466.665 285.702 466.665 292.04C466.665 298.379 471.822 303.535 478.16 303.535C484.498 303.535 489.655 298.379 489.655 292.04C489.655 285.702 484.498 280.545 478.16 280.545Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }